var map = {
	"./apple-touch-icon-retina.png": 1731,
	"./apple-touch-icon.png": 1732,
	"./chatdesk-logo.png": 1733,
	"./chatdesk_video_thumbnail.png": 751,
	"./check-mark.png": 1734,
	"./delighted.png": 1735,
	"./facebook.png": 711,
	"./favicon16.png": 1736,
	"./favicon32.png": 1737,
	"./favicon48.png": 1738,
	"./front.png": 714,
	"./gladly.png": 1739,
	"./gorgias.png": 1740,
	"./helpscout.png": 715,
	"./icon_business.png": 248,
	"./icon_gladly.png": 752,
	"./icon_gorgias.png": 753,
	"./icon_lock.png": 1741,
	"./icon_reamaze.png": 754,
	"./icon_shopify.png": 755,
	"./icon_status_green.png": 756,
	"./icon_status_red.png": 757,
	"./icon_status_yellow.png": 758,
	"./icon_twitter.png": 1742,
	"./icons/icon_thumbs_up.png": 759,
	"./instagram.png": 712,
	"./kustomer.png": 760,
	"./live_agent.png": 1743,
	"./logos/logo_dixa.png": 523,
	"./logos/logo_reamaze.png": 346,
	"./logos/logo_tiktok_shop.png": 524,
	"./no-image-rect.png": 1744,
	"./no-image.png": 1745,
	"./profile_pic_grace.png": 1746,
	"./profile_pic_tara.png": 761,
	"./reamaze.png": 1747,
	"./salesforce_service_cloud.png": 1748,
	"./shopify.png": 1749,
	"./skin/database_add.png": 1750,
	"./skin/database_delete.png": 1751,
	"./skin/database_edit.png": 1752,
	"./skin/database_save.png": 1753,
	"./skin/database_table.png": 1754,
	"./skin/exclamation.png": 1755,
	"./skin/house.png": 1756,
	"./skin/information.png": 1757,
	"./stamped.png": 1758,
	"./tick.png": 1759,
	"./tiktok.png": 716,
	"./twitter.png": 710,
	"./yotpo.png": 1760,
	"./zendesk-chat.png": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1730;